var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"mix-blend-mode-multiply",attrs:{"src":"/img/error500.gif","max-width":"90%","max-height":"50%","contain":"","alt":""}}),_c('p',[_vm._v("Une erreur est survenue, merci de réessayer ultérieurement.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }